export class WizardStepQueue {
  public get isEmpty(): boolean {
    return !this.queue.length;
  }

  private queue: Array<string> = [];

  registerRequiredStep(step: string | Event): void {
    this.queue.push(step as string);
  }

  unregisterRequiredStep(step: string | Event): void {
    this.queue = this.queue.filter((item) => step !== item);
  }

  registerStepDisplay(step: string): void {
    this.queue = this.queue.filter((item) => step !== item);
  }

  getQueue(): Array<string> {
    return [...this.queue];
  }

  clear(): void {
    this.queue = [];
  }
}
